import React from "react"
import PropTypes from "prop-types"
import { reduxForm } from "redux-form"
import { formName } from "../../../../constants/forms"

// Import Components
import DetailCreateFormStyle from "./style"
import { ReduxFormTextarea, ReduxFormInput } from "../../../Shared/reduxForm"
import { Button } from "../../../Shared"

DetailCreateForm.propTypes = {
  // from parent component
  onSubmit: PropTypes.func,
  disabledSubmit: PropTypes.bool
}

function DetailCreateForm({ handleSubmit, onSubmit, pristine, submitting, invalid }) {

  return (
    <DetailCreateFormStyle>
      <form
        noValidate
        onSubmit={handleSubmit(onSubmit)}
        className="available-rules__form"
      >
        <div className="available-rules__column fields">
          <ReduxFormInput
            name="name"
            label="Rule name:"
          />
          <ReduxFormTextarea
            name="explanation"
            label="Design rule description:"
          />
        </div>
        <div className="available-rules__button">
          <Button
            size="large"
            type="submit"
            width={200}
            disabled={pristine || submitting || invalid}
          >
            Save
          </Button>
        </div>
      </form>
    </DetailCreateFormStyle>
  )
}

export default reduxForm({
  form: formName.availableDesignRulesCreateForm
})(DetailCreateForm)
